module.exports = __webpack_public_path__ + "static/img/queryRequest.11767473.png";